/* @refresh reload */
import { render } from "solid-js/web"
import "./index.css"
import Swarm from "./Swarm.tsx"
import { SwarmProvider } from "./SwarmContext"
import { appEnv } from "./lib/appEnv.ts"
import { LiveGatingProvider } from "./gating/provider/live.tsx"
import { gatingClientKey } from "./lib/gatingClientKey.ts"
import { swarmVariant } from "./lib/swarmVariant.tsx"
;(async function main() {
	// In dev mode, we use MSW to mock the API.
	if (appEnv === "DEVELOPMENT" && import.meta.env.VITE_RUN_WITH_MOCK_DATA) {
		console.log(`
			██████╗ ███████╗██╗   ██╗    ███╗   ███╗ ██████╗ ██████╗ ███████╗██╗
			██╔══██╗██╔════╝██║   ██║    ████╗ ████║██╔═══██╗██╔══██╗██╔════╝██║
			██║  ██║█████╗  ██║   ██║    ██╔████╔██║██║   ██║██║  ██║█████╗  ██║
			██║  ██║██╔══╝  ╚██╗ ██╔╝    ██║╚██╔╝██║██║   ██║██║  ██║██╔══╝  ╚═╝
			██████╔╝███████╗ ╚████╔╝     ██║ ╚═╝ ██║╚██████╔╝██████╔╝███████╗██╗
			╚═════╝ ╚══════╝  ╚═══╝      ╚═╝     ╚═╝ ╚═════╝ ╚═════╝ ╚══════╝╚═╝

			Mocking API responses for development.
		`)

		const { worker } = await import("./mocks/browser")
		await worker.start({
			onUnhandledRequest: "warn",
		})
	}

	const root = document.getElementById("root")

	render(
		() => (
			<LiveGatingProvider appEnv={appEnv} sdkKey={gatingClientKey} user={{ userID: `anon-dashboard-${swarmVariant}` }}>
				<SwarmProvider>
					<Swarm />
				</SwarmProvider>
			</LiveGatingProvider>
		),
		root!,
	)
})()
